import React, { Component } from 'react';
import PropTypes from 'prop-types';
import printJS from 'print-js';
import styled from 'styled-components';
import { Card, CardTitle, CardHeader, CardText } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import IconButton from 'material-ui/IconButton';
import MenuItem from 'material-ui/MenuItem';
import IconMenu from 'material-ui/IconMenu';
import Chip from 'material-ui/Chip';
import Avatar from 'material-ui/Avatar';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete-forever';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import { theme } from '../../utils/getTheme';

const editWord = 'MA#EDIT#CORPORATE';
const CardIcon = styled.div`
  position: absolute;
  top: 16px;
  right: 40px;
`;

const RemarksContainer = styled.div`
  margin-top: 16px;
`;

const ContentContainer = styled.div`
  & > * + * {
    margin-top: 16px;
  }
`;

const EducationContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const EducationWrapper = styled.div`
  font-weight: 600;
  width: 30%;
`;

const DetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
`;

const DetailWrapper = styled.div`
  font-weight: 600;
  width: 40%;
`;

const ChipsContainer = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

const DownloadContainer = styled.div``;

const style = {
  headerStyle: {
    paddingLeft: 0,
  },
  textStyle: {
    paddingTop: 0,
  },
};

const formattedDate = (date) => {
  const newDate = new Date(date);

  return `${newDate.getFullYear()}-${newDate.getMonth()}-${newDate.getDate()}`;
};

class EarlyBirdCorporateCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editPasswordModal: false,
      editPassword: '',
      editPasswordErrorMessage: undefined,
    };
  }

  openEditPasswordModal = () => {
    this.setState(() => ({
      editPasswordModal: true,
    }));
  };

  closeEditPasswordModal = () => {
    this.setState(() => ({
      editPasswordModal: false,
    }));
  };

  moveToEdit = (id) => {
    const { editPassword } = this.state;
    const { history } = this.props;
    if (editPassword === editWord) {
      history.push(`/edit/corporate/${id}`);
    } else {
      this.setState(() => ({
        editPassword: '',
        editPasswordErrorMessage: 'Incorrect Password',
      }));
    }
  };

  render() {
    const {
      companyName,
      companyType,
      companyDescription,
      website,
      onlinePortal,
      address,
      state,
      city,
      contacts,
      partnership,
      jobs,
      remarks,
      timestamp,
      corporateId,
    } = this.props;

    const {
      editPasswordModal,
      editPassword,
      editPasswordErrorMessage,
    } = this.state;

    return (
      <div>
        <Card style={{ position: 'relative' }}>
          <CardIcon>
            <IconMenu
              iconButtonElement={
                <IconButton>
                  <MoreVertIcon />
                </IconButton>
              }
              targetOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
              <MenuItem
                leftIcon={<EditIcon />}
                primaryText="Edit"
                onTouchTap={() => {
                  this.openEditPasswordModal();
                }}
              />
              <MenuItem leftIcon={<DeleteIcon />} primaryText="Delete" />
            </IconMenu>
          </CardIcon>
          <CardTitle
            title={companyName}
            subtitle={`${companyType} | ${website} | ${formattedDate(
              timestamp,
            )}`}
            actAsExpander
            showExpandableButton
          />

          <CardText expandable style={style.textStyle}>
            {onlinePortal ? (
              <MenuItem
                leftIcon={<CheckCircle color={theme.primary1Color} />}
                disableTouchRipple
                primaryText="Online Portal"
              />
            ) : null}

            <CardHeader
              title={`Address - ${address}, ${state}, ${city}`}
              style={style.headerStyle}
            />
            <CardHeader
              title="Company Description"
              style={{ paddingLeft: 0 }}
            />
            {companyDescription
              .split('\n')
              .map((text, i) => <p key={i}>{text}</p>)}
            <CardTitle
              title="Contact Information"
              style={style.headerStyle}
              titleStyle={{ fontSize: '20px' }}
            />
            <ContentContainer>
              {contacts.map(contact => (
                <Card key={contact.id}>
                  <CardHeader
                    title={contact.name}
                    subtitle={`${contact.designation} | ${contact.contact} | ${
                      contact.email
                    }`}
                  />
                </Card>
              ))}
            </ContentContainer>

            {partnership === 'Campus Partner' ? (
              <div>
                <CardTitle
                  title="Campus Partner - Jobs"
                  style={style.headerStyle}
                  titleStyle={{ fontSize: '20px' }}
                />
                <ContentContainer>
                  {jobs.map(job => (
                    <Card key={job.id} style={{ position: 'relative' }}>
                      <CardIcon>
                        <IconButton
                          onClick={() => {
                            printJS({
                              printable: `${job.id}`,
                              type: 'html',
                              header: `${companyName}`,
                              documentTitle: 'My Anatomy Ventures',
                            });
                          }}
                        >
                          <DownloadIcon color={theme.primary1Color} />
                        </IconButton>
                      </CardIcon>
                      <DownloadContainer id={job.id}>
                        <CardHeader
                          title={job.jobTitle}
                          subtitle={` ₹${job.ctc} | ${job.employmentType} | ${
                            job.employmentType === 'Internship'
                              ? job.duration
                              : ''
                          }`}
                        />
                        <CardText>
                          <b>Job Location: </b> {job.jobLocation}
                          <br /> <br />
                          <b>Number of Requirements: </b>
                          {job.requirements}
                          <br /> <br />
                          <CardHeader
                            title="Job Description"
                            style={{ paddingLeft: 0 }}
                          />
                          {job.jobDescription
                            .split('\n')
                            .map((text, i) => <p key={i}>{text}</p>)}
                          {job.eligibility ? (
                            <div>
                              <CardHeader
                                title="Eligibility Criteria"
                                style={{ paddingLeft: 0, fontSize: 18 }}
                              />
                              <EducationContainer>
                                <EducationWrapper>
                                  Tenth Marks - {job.eligibility.eligibility10}
                                </EducationWrapper>
                                <EducationWrapper>
                                  Twelfth Marks -{' '}
                                  {job.eligibility.eligibility12}
                                </EducationWrapper>
                                <EducationWrapper>
                                  Graduation Marks -{' '}
                                  {job.eligibility.eligibilityGrad}
                                </EducationWrapper>
                              </EducationContainer>
                              <DetailContainer>
                                <DetailWrapper>
                                  Backlogs - {job.eligibility.backlogs}
                                </DetailWrapper>
                                <DetailWrapper>
                                  Year gaps - {job.eligibility.yeardrop}
                                </DetailWrapper>
                              </DetailContainer>
                              <DetailWrapper>Eligible Streams</DetailWrapper>
                              <ChipsContainer>
                                {job.eligibility.eligibleStreams.map(
                                  (stream, index) => (
                                    <Chip
                                      key={stream.id}
                                      style={{
                                        marginRight: 8,
                                        marginBottom: 8,
                                      }}
                                    >
                                      <Avatar>{index + 1}</Avatar>
                                      {stream.stream}
                                    </Chip>
                                  ),
                                )}
                              </ChipsContainer>
                              <DetailWrapper>Eligible Degrees</DetailWrapper>
                              <ChipsContainer>
                                {job.eligibility.eligibleDegree.map(
                                  (degree, index) => (
                                    <Chip
                                      key={degree.id}
                                      style={{
                                        marginRight: 8,
                                        marginBottom: 8,
                                      }}
                                    >
                                      <Avatar>{index + 1}</Avatar>
                                      {degree.degree}
                                    </Chip>
                                  ),
                                )}
                              </ChipsContainer>
                            </div>
                          ) : null}
                        </CardText>
                      </DownloadContainer>
                    </Card>
                  ))}
                </ContentContainer>
              </div>
            ) : (
              <CardTitle
                title="Endorsment Partner"
                style={style.headerStyle}
                titleStyle={{ fontSize: '20px' }}
              />
            )}
            {remarks ? (
              <RemarksContainer>
                <b>Remarks</b>
                <br />
                {remarks}
              </RemarksContainer>
            ) : null}
          </CardText>
        </Card>
        <Dialog
          title="Edit Password"
          actions={[
            <RaisedButton
              label="Submit"
              primary
              onTouchTap={() => {
                this.moveToEdit(corporateId);
              }}
            />,
            <FlatButton
              label="Close"
              primary
              onTouchTap={() => {
                this.closeEditPasswordModal();
              }}
            />,
          ]}
          open={editPasswordModal}
          onRequestClose={this.closeEditPasswordModal}
        >
          <TextField
            floatingLabelText="Password"
            hintText="********"
            type="password"
            value={editPassword}
            onChange={(_, value) => {
              this.setState(() => ({
                editPassword: value,
              }));
            }}
            errorText={editPasswordErrorMessage}
          />
        </Dialog>
      </div>
    );
  }
}

EarlyBirdCorporateCard.propTypes = {
  corporateId: PropTypes.string.isRequired,
  timestamp: PropTypes.number.isRequired,
  companyName: PropTypes.string.isRequired,
  companyType: PropTypes.string.isRequired,
  companyDescription: PropTypes.string.isRequired,
  website: PropTypes.string.isRequired,
  onlinePortal: PropTypes.bool.isRequired,
  state: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  contacts: PropTypes.array.isRequired, // eslint-disable-line
  history: PropTypes.object.isRequired, // eslint-disable-line
  partnership: PropTypes.string.isRequired,
  jobs: PropTypes.array, // eslint-disable-line
  remarks: PropTypes.string.isRequired,
  eligibility: PropTypes.object, // eslint-disable-line
};

EarlyBirdCorporateCard.defaultProps = {
  jobs: [],
  eligibility: undefined,
};

export default EarlyBirdCorporateCard;



// WEBPACK FOOTER //
// ./src/components/EarlyBirdCorporateCard/EarlyBirdCorporateCard.js